import { SVGProps, Ref, forwardRef } from 'react';

export const VkSquareSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.984 1.984C1 2.968 1 4.552 1 7.72v.56c0 3.168 0 4.752.984 5.736S4.552 15 7.72 15h.56c3.168 0 4.752 0 5.736-.984S15 11.448 15 8.28v-.56c0-3.168 0-4.752-.984-5.736S11.448 1 8.28 1h-.56c-3.168 0-4.752 0-5.736.984m1.378 3.274c.076 3.64 1.896 5.828 5.087 5.828h.181V9.003c1.172.117 2.06.975 2.415 2.083h1.657c-.455-1.657-1.651-2.573-2.398-2.923.747-.431 1.797-1.481 2.048-2.905h-1.505C10.52 6.413 9.552 7.463 8.63 7.563V5.258H7.125v4.037c-.933-.233-2.112-1.365-2.164-4.037z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VkSquareSolidSize16Glyph.displayName = 'VkSquareSolidSize16Glyph';
